import heartFilledNormal from '@breuni-ui/bdk/design-tokens/images/icons/f-ic-16_heart.svg?element';
import heartNormal from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-16_heart.svg?element';
import heartFilledLarge from '@breuni-ui/bdk/design-tokens/images/icons/f-ic-24_heart.svg?element';
import heartLarge from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-24_heart.svg?element';
import { hideIconFromAssistiveTechnology } from '../icon/icon-accessibility.js';
import { ButtonSize } from './button-size.js';

export function renderHeartIcon(size: ButtonSize, selected: boolean) {
  let icon: SVGElement;
  if (size === ButtonSize.large) {
    icon = selected ? heartFilledLarge() : heartLarge();
  } else {
    icon = selected ? heartFilledNormal() : heartNormal();
  }
  return hideIconFromAssistiveTechnology(icon);
}
